import React from "react";
import classNames from "../classNames";

function noop() {}

const defaultProps = {
  onChange: noop,
  type: "checkbox",
};

function CustomCheckbox({ className, onChange, label, type, ...props }) {
  const classes = classNames("form-check", className);
  const _onChange = (event) => {
    onChange(event.target.checked);
  };
  return (
    // <div className={classes}>
    //   <input
    //     type={type}
    //     className="form-check-input"
    //     onChange={_onChange}
    //     {...props}
    //   />
    //   <label className="form-check-label" htmlFor={props.id}>
    //     {label}
    //   </label>
    // </div>
    <label className="ios-checkbox green">
      <input type="checkbox" onChange={_onChange} />
      <div className="checkbox-wrapper">
        <div className="checkbox-bg"></div>
        <svg fill="none" viewBox="0 0 24 24" className="checkbox-icon">
          <path
            stroke-linejoin="round"
            stroke-linecap="round"
            stroke-width="3"
            stroke="currentColor"
            d="M4 12L10 18L20 6"
            className="check-path"
          ></path>
        </svg>
      </div>
    </label>
  );
}

CustomCheckbox.defaultProps = defaultProps;
export default CustomCheckbox;
